/* eslint-disable */

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { HiX } from "react-icons/hi";
import { MdHelpOutline, MdDownload } from "react-icons/md";
import Links from "./components/Links";
import { getRandomFeatureFlash } from "constants/featureFlash";
import { openNeedAssistanceForm } from "@utils/linkHelpers";

import {
  renderThumb,
  renderTrack,
  renderView,
  renderViewMini,
} from "components/scrollbar/Scrollbar";
import { Scrollbars } from "react-custom-scrollbars-2";
import routes from "routes";
import Card from "components/card";
import Switch from "components/switch";

function SidebarHorizon(props: {
  open: boolean;
  onClose: React.MouseEventHandler<HTMLSpanElement>;
  variant?: string;
  [x: string]: any;
}) {
  const { open, onClose, variant, mini, hovered, setHovered } = props;
  const navigate = useNavigate();
  const [featureFlash] = useState(() => getRandomFeatureFlash());

  // Mobile integration switch state
  const [mobileIntegration, setMobileIntegration] = useState(() => {
    const saved = localStorage.getItem('mobileIntegration');
    return saved ? JSON.parse(saved) : false;
  });

  useEffect(() => {
    localStorage.setItem('mobileIntegration', JSON.stringify(mobileIntegration));
  }, [mobileIntegration]);

  // Handle switch toggle with navigation
  const handleSwitchToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.checked;
    setMobileIntegration(newValue);
    
    // Navigate based on switch state
    if (newValue) {
      navigate('/admin/dashboards/default');
    } else {
      navigate('/admin/intros/dashboard');
    }
  };

  // Filter routes based on mobile integration setting
  const filteredRoutes = routes.filter(route => {
    if (mobileIntegration) {
      return true; // Show all routes when mobile integration is on
    } else {
      // Only show specific routes when mobile integration is off
      const allowedRoutes = [
        "Intros Dashboard",
        "Latte AI Intros",
        "Workflows",
        "User Management",
        "Integrations"
      ];
      return allowedRoutes.includes(route.name);
    }
  });
  return (
    <div
      className={`sm:none ${
        mini === false
          ? "w-[285px]"
          : mini === true && hovered === true
          ? "w-[285px]"
          : "w-[285px] xl:!w-[120px]"
      } duration-175 linear fixed !z-50 min-h-full transition-all md:!z-50 lg:!z-50 xl:!z-0 ${
        variant === "auth" ? "xl:hidden" : "xl:block"
      } ${open ? "" : "-translate-x-[105%]"}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <Card
        extra={`ml-3 w-full h-[96.5vh] sm:mr-4 sm:my-4 m-7 !rounded-[20px]`}
      >
        <Scrollbars
          autoHide
          renderTrackVertical={renderTrack}
          renderThumbVertical={renderThumb}
          renderView={
            mini === false
              ? renderView
              : mini === true && hovered === true
              ? renderView
              : renderViewMini
          }
        >
          <div className="flex h-full flex-col justify-between">
            <div>
              <span
                className="absolute top-4 right-4 block cursor-pointer xl:hidden"
                onClick={onClose}
              >
                <HiX />
              </span>
              <div className={`ml-[52px] mt-[44px] flex items-center `}>
                <div
                  className={`mt-1 ml-1 h-2.5 font-poppins text-[26px] font-bold uppercase text-navy-700 dark:text-white ${
                    mini === false
                      ? "block"
                      : mini === true && hovered === true
                      ? "block"
                      : "hidden"
                  }`}
                >
                  Latte <span className="font-medium">Admin</span>
                </div>
                <div
                  className={`mt-1 ml-1 h-2.5 font-poppins text-[26px] font-bold uppercase text-navy-700 dark:text-white ${
                    mini === false
                      ? "hidden"
                      : mini === true && hovered === true
                      ? "hidden"
                      : "block"
                  }`}
                >
                  H
                </div>
              </div>
              <div className="mt-[58px] mb-7 h-px bg-gray-200 dark:bg-white/10" />
              
              {/* Switch Section */}
              <div className={`mx-8 mb-6 ${
                mini === false
                  ? "block"
                  : mini === true && hovered === true
                  ? "block"
                  : "hidden"
              }`}>
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                    Mobile Integration
                  </span>
                  <Switch 
                    id="mobile-integration-switch"
                    checked={mobileIntegration}
                    onChange={handleSwitchToggle}
                  />
                </div>
              </div>
              
              {/* Nav item */}
              <ul>
                <Links mini={mini} hovered={hovered} routes={filteredRoutes} />
              </ul>
            </div>
            {/* Free Horizon Card    */}
            <div className="mt-[28px] mb-[30px]">
              {/* <div className="flex justify-center">
                <SidebarCard mini={mini} hovered={hovered} />
              </div> */}
              <div className="w-auto max-w-lg px-4 space-y-5">
                {/* Feature Flash */}
                <div className={`mt-[28px] rounded-xl border border-green-200 bg-green-50 dark:border-green-800 dark:bg-green-900/20 px-4 py-3 ${
                  mini === false
                    ? "block"
                    : mini === true && hovered === true
                    ? "block"
                    : "hidden"
                }`}>
                  <div>
                    <p className="text-xs font-semibold text-green-800 dark:text-green-200 mb-1">{featureFlash.title}</p>
                    <p className="text-xs text-green-700 dark:text-green-300 leading-relaxed">
                      {featureFlash.content}
                    </p>
                  </div>
                </div>

                <button
                  onClick={openNeedAssistanceForm}
                  className="block w-full"
                >
                  <div className="flex items-center justify-between rounded-xl border border-gray-200 px-4 py-[21px] hover:bg-gray-50 dark:hover:bg-white/10 dark:!border-white/10">
                    <div className="flex items-center justify-center gap-2">
                      <MdHelpOutline className="text-blue-500 h-5 w-5" />
                      <h4 className="font-dm text-gray-700 dark:text-white">Need Assistance</h4>
                    </div>
                  </div>
                </button>

                <a href="https://docs.google.com/forms/d/1zXU4WgZWBexThPse5K4WhDn2bgVk6QUcZ6HsjH_6mu0/edit" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block"
                >
                  <div className="flex items-center justify-between rounded-xl border border-gray-200 px-4 py-[20px] dark:!border-white/10 hover:bg-gray-50 dark:hover:bg-white/10 transition cursor-pointer">
                    <div className="flex items-center gap-2 text-brand-500 dark:text-white">
                      <MdDownload className="text-green-500 h-5 w-5" />
                      <h6 className="font-dm text-gray-700 dark:text-white">Data Request</h6>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </Scrollbars>
      </Card>
    </div>
  );
}

export default SidebarHorizon;
